import {Injectable} from '@angular/core';
import {ApiService, JsonResult} from '../core/services/api.service';
import {HandleErrorService} from './handle-error.service';
import {Observable} from 'rxjs';
import {HttpEvent, HttpResponse} from '@angular/common/http';
import {catchError, tap} from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class RequestProceduresService {

  constructor(
    private serviceApi: ApiService,
    private handleError: HandleErrorService
  ) {
  }

  get(params: object): Observable<HttpResponse<JsonResult<any[]>>> {
    return this.serviceApi.forFilterPost<any>(`AgencyVirtual/Filter`, params);
  }

  getFiles(id: number) {
    return this.serviceApi.get(`AgencyVirtual/Virtual/Files/${id}`);
  }

  getHistory(id: number) {
    return this.serviceApi.get(`AgencyVirtual/Virtual/History/${id}`);
  }

  getStates(list: number, id?: number): Observable<Array<{ finalize: boolean, id: number, name: string, success?: boolean }>> {
    // @ts-ignore
    return this.serviceApi.get(`Master/Virtual/${list}/Id/${id || 0}`);
  }

  updateState(params: object): Observable<JsonResult<any[]>> {
    return this.serviceApi.post<any>(`AgencyVirtual/ConsultsInformationStatus`, params).pipe(
      catchError(this.handleError.catchHttpError),
      tap((data: { valid: boolean, message: string }) => {
        if (data.valid) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Aceptar',
            text: data.message
          }).then(() => Swal.close());
        }
      })
    );
  }     
}
